export interface OrgExclusion { id: string; text: string; }
export interface LaborRate { id: string; role: string; rate: number; }

export const DEFAULT_LABOR_RATES: LaborRate[] = [
  {id:"lr1",role:"Laborer",rate:65},
  {id:"lr2",role:"Carpenter",rate:95},
  {id:"lr3",role:"Foreman",rate:110},
  {id:"lr4",role:"Assistant Project Manager",rate:120},
  {id:"lr5",role:"Project Manager",rate:145},
  {id:"lr6",role:"Superintendent",rate:135},
];

export const DEFAULT_ORG_EXCLUSIONS: OrgExclusion[] = [
  {id:"oex1",text:"Permit fees and associated costs"},
  {id:"oex2",text:"Owner-furnished equipment and materials"},
  {id:"oex3",text:"Hazardous material abatement and remediation"},
  {id:"oex4",text:"Site survey and geotechnical investigation"},
  {id:"oex5",text:"Architect and engineering design fees"},
  {id:"oex6",text:"Third-party testing and special inspections"},
  {id:"oex7",text:"Utility connection and tap fees"},
  {id:"oex8",text:"Furniture, fixtures, and equipment (FF&E)"},
  {id:"oex9",text:"Window treatments and soft furnishings"},
  {id:"oex10",text:"Landscaping and irrigation beyond limits of construction"},
  {id:"oex11",text:"Security and low-voltage systems"},
  {id:"oex12",text:"Change orders arising from owner-directed scope additions"},
];
